import BaseInputError from 'components/generics/inputs/BaseInputError';
import { InputHTMLAttributes } from 'react';
import inputClasses from '../index.module.scss';

const DEFAULT_PLACEHOLDER = 'MM/DD/YYYY';
interface DateInputProps extends InputHTMLAttributes<HTMLInputElement> {
  errorMessage?: string;
  noBorder?: boolean;
  inputClassName?: string;
  withPlaceHolderTransition?: boolean;
  placeholderClass?: string;
  label?: string;
}

const DateInput = ({
  label,
  errorMessage,
  noBorder,
  inputClassName,
  placeholderClass,
  withPlaceHolderTransition,
  ...props
}: DateInputProps): JSX.Element => {
  return (
    <div>
      <label className={inputClasses.label}>{label}</label>
      <BaseInputError
        autoComplete={'bday'}
        type={'tel'}
        inputMode="numeric"
        mask={'99/99/9999'}
        maskChar={''}
        placeholder={DEFAULT_PLACEHOLDER}
        errorMessage={errorMessage}
        placeholderClass={placeholderClass}
        noBorder={noBorder}
        inputClassName={inputClassName}
        withPlaceHolderTransition={withPlaceHolderTransition}
        {...props}
      />
    </div>
  );
};

export default DateInput;
